<!--
マイクを選択するコンポーネント
デバイス一覧取得、選択情報はDeviceStoreを直接利用するため、上位のコンポーネントにてDeviceStoreに情報を入れておくこと
 -->
<script setup lang="ts">
  import { useDeviceStore } from "~/stores/DeviceStore";

  // カメラ、マイクの一覧情報
  const deviceStore = useDeviceStore();
  // 選択されたマイク
  const selectedMicrophoneLabel = computed<string>({
    get: () => deviceStore.selectedMicrophoneLabel,
    set: value => {
      deviceStore.selectMicrophoneByLabel(value);
    },
  });
</script>

<template>
  <div class="text-left label-text">
    <span>マイク設定</span>
    <AtomsInputSelect
      v-model:selected-item="selectedMicrophoneLabel"
      :choices="deviceStore.microphoneLabels"
      class="mt-1"
    />
  </div>
</template>

<style lang="scss" scoped>
  .label-text {
    font-size: 16px;
    font-weight: 700;
    line-height: 1.8em;
  }
</style>
